import { render, staticRenderFns } from "./vaccin.vue?vue&type=template&id=b5596af4&scoped=true"
import script from "./vaccin.vue?vue&type=script&lang=js"
export * from "./vaccin.vue?vue&type=script&lang=js"
import style0 from "./vaccin.vue?vue&type=style&index=0&id=b5596af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5596af4",
  null
  
)

export default component.exports